import { getJsonLdBase } from '@utils/jsonLdHelpers';
import Head from 'next/head';
import React from 'react';
import { ArticleJsonLdProps } from './JsonLd.types';

export const ArticleJsonLd: React.FC<ArticleJsonLdProps> = ({ url, ...props }) => {
  const jsonLdData = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    url,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': url,
    },
    ...getJsonLdBase(props),
  };

  return (
    <Head>
      <script
        type="application/ld+json"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLdData) }}
      />
    </Head>
  );
};
